import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const steps = [{
  id: 1,
  label: 'STEP 01',
  title: 'Build your prospect list',
  description: 'Build a targeted prospect list based on the industry, location, company size, and roles you want to reach. Starting with the right contacts helps you focus your outreach, improve reply rates, and spend time on leads that actually match your ideal customer.',
  image: 'https://cdn.magicpatterns.com/uploads/bceZhMw5x2T7V3Y7USXfKT/search_filter.gif',
  alt: 'Openmart search and filter interface for building prospect lists'
}, {
  id: 2,
  label: 'STEP 02',
  title: 'Create personalized emails faster with templates',
  description: 'Use ready-made templates to create personalized outreach emails without starting from scratch every time. Built-in follow-ups make it easy to automate the full sequence, stay consistent across touchpoints, and keep prospects moving without extra manual work.',
  image: 'https://cdn.magicpatterns.com/uploads/m1eZncrGZ3MXrRchsAxKCq/outreach_email_template.png',
  alt: 'Openmart email sequence editor with personalized outreach template'
}, {
  id: 3,
  label: 'STEP 03',
  title: 'Keep track of your email sequencing with analytics',
  description: 'Monitor opens, clicks, replies, and follow-up performance in one place to understand what is working. With clear sequencing analytics, you can optimize your messaging, improve timing, and drive better results from every campaign.',
  image: 'https://cdn.magicpatterns.com/uploads/9T1dzfaXUowRgu7cWmEraP/email_sequencing_analytic.png',
  alt: 'Openmart email sequencing analytics dashboard with engagement metrics'
}];
export function SequenceProductTour() {
  return <section className="py-40 bg-white relative overflow-hidden" data-id="element-1616">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1617">
        <div className="text-center max-w-3xl mx-auto mb-32" data-id="element-1618">
          <div className="text-sm font-bold text-blue-600 tracking-widest uppercase mb-4" data-id="element-1619">
            Product Tour
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight tracking-tight" data-id="element-1620">
            See the <span className="text-blue-600" data-id="element-1621">product in action</span>
          </h2>
          <p className="text-xl text-slate-500 leading-relaxed" data-id="element-1622">
            From finding leads to booking meetings with automated email
            sequences.
          </p>
        </div>

        <div className="space-y-36 md:space-y-52" data-id="element-1623">
          {steps.map((step, index) => {
          const isEven = index % 2 !== 0;
          return <div key={step.id} className={`flex flex-col ${isEven ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-16 lg:gap-28 items-center`} data-id="element-1624">
                <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.7,
              delay: 0,
              ease: [0.25, 0.1, 0.25, 1]
            }} className="w-full lg:w-5/12 space-y-8" data-id="element-1625">
                  <div className="text-sm font-bold text-slate-400 tracking-widest uppercase" data-id="element-1626">
                    {step.label}
                  </div>
                  <h3 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight leading-tight" data-id="element-1627">
                    {step.title}
                  </h3>
                  <p className="text-lg text-slate-500 leading-relaxed" data-id="element-1628">
                    {step.description}
                  </p>
                  <div className="pt-2" data-id="element-1629">
                    <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-blue-600 font-semibold hover:text-blue-700 transition-colors group" data-id="element-1630">
                      Try for free
                      <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-1631" />
                    </a>
                  </div>
                </motion.div>

                <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.7,
              delay: 0.15,
              ease: [0.25, 0.1, 0.25, 1]
            }} className="w-full lg:w-7/12" data-id="element-1632">
                  <div className="w-full rounded-2xl overflow-hidden shadow-xl ring-1 ring-black/5" data-id="element-1633">
                    <img src={step.image} alt={step.alt} className="w-full h-auto block" loading="lazy" data-id="element-1634" />
                  </div>
                </motion.div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}